// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1f67f113e16f2d7c3824","655":"d05dd31753a0a9152b06"}[chunkId] + ".js";
};